import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { servicesData } from '../../data/servicesData';
import categoriesService from '../../services/categoriesService';

// Action asynchrone pour récupérer les statuts des catégories depuis l'API
export const fetchCategoriesStatus = createAsyncThunk(
  'services/fetchCategoriesStatus',
  async () => {
    const status = await categoriesService.getCategoriesStatus();
    return status;
  }
);

const initialState = {
  availableServices: servicesData,
  serviceStatus: {}, // Sera rempli par l'API au démarrage
  currentService: null,
  statusLoading: true, // true par défaut car on attend la première requête API
  isInitialLoad: true, // Devient false après le premier chargement réussi
  statusError: null,
  selectedOptions: {
    cloudVPS: {
      os: null,
      osVersion: null,
      duration: null,
      configuration: null
    },
    orchestrator: {
      type: null,
      version: null,
      duration: null,
      configuration: null
    },
    dbaas: {
      database: null,
      dbVersion: null,
      duration: null,
      configuration: null,
      ramConfiguration: null
    },
    domains: {
      domainName: '',
      extension: null,
      paymentYears: null,
      isAvailable: null,
      contactInfo: {
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        adresse: '',
        ville: '',
        ns1: '',
        ns2: ''
      }
    },
    cmsaas: {
      cms: null,
      configuration: null
    },
    dedicatedServer: {
      os: null,
      osVersion: null,
      configuration: null
    }
  },
  loading: false,
  error: null
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    setCurrentService: (state, action) => {
      // Clear previous service options when switching services
      if (state.currentService && state.currentService !== action.payload) {
        state.selectedOptions = initialState.selectedOptions;
      }
      state.currentService = action.payload;
    },
    updateServiceOption: (state, action) => {
      const { service, option, value } = action.payload;
      if (state.selectedOptions[service]) {
        state.selectedOptions[service][option] = value;
      }
    },
    updateDomainContactInfo: (state, action) => {
      const { field, value } = action.payload;
      state.selectedOptions.domains.contactInfo[field] = value;
    },
    setDomainAvailability: (state, action) => {
      state.selectedOptions.domains.isAvailable = action.payload;
    },
    resetServiceOptions: (state, action) => {
      const service = action.payload;
      if (service && state.selectedOptions[service]) {
        state.selectedOptions[service] = initialState.selectedOptions[service];
      } else {
        state.selectedOptions = initialState.selectedOptions;
      }
    },
    toggleServiceStatus: (state, action) => {
      const { service, enabled } = action.payload;
      if (state.serviceStatus[service]) {
        state.serviceStatus[service].enabled = enabled;
      }
    },
    setServiceMaintenance: (state, action) => {
      const { service, maintenance } = action.payload;
      if (state.serviceStatus[service]) {
        state.serviceStatus[service].maintenance = maintenance;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesStatus.pending, (state) => {
        // Ne montrer le loading que si c'est le premier chargement
        state.statusLoading = state.isInitialLoad;
        state.statusError = null;
      })
      .addCase(fetchCategoriesStatus.fulfilled, (state, action) => {
        state.statusLoading = false;
        state.isInitialLoad = false; // Premier chargement terminé
        state.serviceStatus = action.payload;
        state.statusError = null;
      })
      .addCase(fetchCategoriesStatus.rejected, (state, action) => {
        state.statusLoading = false;
        state.isInitialLoad = false; // Premier chargement terminé (même en erreur)
        state.statusError = action.error.message;
        // Garder les statuts par défaut en cas d'erreur
      });
  }
});

export const {
  setCurrentService,
  updateServiceOption,
  updateDomainContactInfo,
  setDomainAvailability,
  resetServiceOptions,
  toggleServiceStatus,
  setServiceMaintenance,
  setLoading,
  setError
} = servicesSlice.actions;

export default servicesSlice.reducer;
